<template>
	<div style="border-radius: 50%; height: 40px; width: 40px">
		<NtaAudioIndicator :playing="playing" width="30px" height="30px" style="margin-top: px; margin-left: 5px" />
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { NtaAudioIndicator } from "@lr-notitia/notitia-ui/components";
import { useAudioPlayerStore } from "../../../../store/alternis/audioPlayer";

const audioPlayerStore = useAudioPlayerStore();

const props = defineProps<{
	audioId: string | undefined;
}>();
const playing = computed(() => (props.audioId ? audioPlayerStore.audioInstances.has(props.audioId) : false));
</script>
